import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { AuthContext } from "../../contexts/auth";
import { useNavigate, useParams } from "react-router-dom";

import { permite_acesso, PegarDados1 } from "../../services/api";

import { set, useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Detalhamento_bolsa from "../Modulos/detalhamento_bolsa";
import Totalizacao_unidade from "../Modulos/totalizacao_unidade";
import Fidelizacao_turma from "../Modulos/Fidelizacao_turma";
import Bolsa_unidade from "../Modulos/bolsa_unidade";
import Bolsa_media_unidade from "../Modulos/Bolsa_media_unidade";
import Bolsa_diretor_unidade from "../Modulos/bolsa_diretor_unidade";
import Bolsa_balcao_unidade from "../Modulos/bolsa_balcao_unidade";
import Bolsa_bolsao_unidade from "../Modulos/bolsa_bolsao_unidade";
import Metas_unidade from "../Modulos/metas_unidade";
import Alunos_Andamento from "../Modulos/alunos_andamento";
import Alunos_novos_renovados_segmento from "../Modulos/novos_renovados_segmento";
import Fidelizacao_serie from "../Modulos/Fidelizacao_serie";
import Fidelizacao_Seg_unidade from "../Modulos/Fidelizacao_seg_unidade";
import Fidelizacao_serie_comparativa_unidade from "../Modulos/fidelizacao_serie_comparativa_unidade";
import Detalhamento_bolsa_tabs from "../Modulos/detalhamento_bolsa_tabs";
import Carteirinhas_pedidos from "../Modulos/detalhamento_pedidos_carteirinhas";
import DashboardMatriculasUnidade from "../Modulos/matriculas_ajustadas_unidade2";
import QTD_turmas from "../Modulos/qtd_turmas";

//nada não


import Checkbox from "../Components/checkbox";

// import { Row, Form, Button, Container, Tab, Tabs, Table, Col } from "react-bootstrap";

import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Table from "react-bootstrap/Table";
import Col from "react-bootstrap/esm/Col";

import Accordion from 'react-bootstrap/Accordion';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import InputGroup from 'react-bootstrap/InputGroup';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';
import Collapse from 'react-bootstrap/Collapse';

import Carrocel from '../Components/carrocel';

import './index.css';

const schema = yup.object({}).required();

const Unidade = () => {

    let { cod_unidade } = useParams();

    const perfil = JSON.parse(localStorage.getItem("perfil"));


    console.log("cod_unidade", cod_unidade);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    const usuario = JSON.parse(localStorage.getItem("user"));
    const token = localStorage.getItem("token");

    // CONTROLE(FUNCIONARIO,TOKEN,COD_UNI)

    const { authenticated, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [acesso, setAcesso] = useState(false);



    const [dataInicio, setDataInicio] = useState('2026-08-28'); // Formato ISO (YYYY-MM-DD) 
    // const [dataFim, setDataFim] = useState(new Date().toISOString().split('T')[0]);
    // const [dataFim, setDataFim] = useState('2027-03-31');
    const amanha = new Date();
    amanha.setDate(amanha.getDate() + 1);
    const novaDataFim = amanha.toISOString().split('T')[0];
    const hoje = new Date();
    const diadehoje = hoje.toISOString().split('T')[0];

    const [dataFim, setDataFim] = useState(diadehoje);

    function formatarData(dataOriginal) {
        // Divide a string da data em ano, mês e dia
        const partes = dataOriginal.split('-');
        // Verifica se a string está no formato correto (ANO-MES-DIA)
        if (partes.length !== 3) {
            return 'Formato de data inválido';
        }
        // Reorganiza as partes da data no formato DIA-MES-ANO
        const dataFormatada = `${partes[2]}-${partes[1]}-${partes[0]}`;
        return dataFormatada;
    }


    console.log("Antes", dataInicio);

    // const [startDate, setStartDate] = useState('2024-09-01');
    // const [endDate, setEndDate] = useState(getCurrentDate());


    const {
        register,
        setValue,
        handleSubmit,
        setFocus,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });



    useEffect(() => {
        (async () => {
            const resultado2 = await permite_acesso(usuario[0].email, token, "Unidade " + cod_unidade);
            setAcesso(resultado2);
        })();
    }, [dataInicio, dataFim]);

    console.log("Acesso:", acesso);

    console.log("Depois", dataInicio);



    if (!acesso) {

        return (
            <div className="AcessoNegado">
                -- ACESSO NEGADO !!! --

                <a href="/login"> Voltar ao Login</a>

            </div>
        )
    }

    const handleData = (e) => {
        e.preventDefault();
        let dti = document.querySelector(
            "input[name = inicio]"
        ).value;
        console.log(dti);
        setDataInicio(dti);
        let dtf = document.querySelector(
            "input[name = fim]"
        ).value;
        console.log(dtf);
        setDataFim(dtf);

    };

    const Experiment = (Nperfil) => {
        if (Nperfil === "GESTOR")
            return (
                <>
                    <NavDropdown.Item href="/unidade/10">Barra da Tijuca</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/01">Bento Ribeiro</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/11">Campo Grande</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/04">Cascadura</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/16">Freguesia</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/15">Ilha do Governador</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/02">Madureira</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/14">Maricá</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/06">Nilópolis</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/17">Recreio</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/03">Santa Cruz</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/09">Seropédica</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/05">Taquara</NavDropdown.Item>
                    <NavDropdown.Item href="/metas">Painel de Metas</NavDropdown.Item>
                    <NavDropdown.Item href="/alunos-cancelados">Alunos Cancelados</NavDropdown.Item>
                    <NavDropdown.Item href="/monitora-geo">Mapa</NavDropdown.Item>

                </>
            );
        if (Nperfil.startsWith("DIRETOR")) {
            var numerosString = Nperfil.replace("DIRETOR", "").trim();
            var numerosArray = numerosString.split("-");
            var codigoDinamico = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/unidade/${cod_unidade}`}>
                        {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });
            codigoDinamico.push(<NavDropdown.Item key="tesouraria" href="/tesouraria"> Tesouraria - Pagamentos </NavDropdown.Item>);
            codigoDinamico.push(<NavDropdown.Item href="/alunos-cancelados">Alunos Cancelados</NavDropdown.Item>);
            codigoDinamico.push(<NavDropdown.Item href="/meus-alunos">Meus Alunos</NavDropdown.Item>);
            codigoDinamico.push(<NavDropdown.Item href="/alunos-nao-renovados">Alunos Não Renovados</NavDropdown.Item>);
            codigoDinamico.push(<NavDropdown.Item href="/metas">Painel de Metas</NavDropdown.Item>);
            codigoDinamico.push(<NavDropdown.Divider />);
            var codigoDinamico2 = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/upload/${cod_unidade}`}>
                        Assinaturas - {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });
            codigoDinamico.push(<NavDropdown title="Assinaturas" id="basic-nav-subdropdown">{codigoDinamico2}</NavDropdown>);


            return (codigoDinamico)


        };
        if (Nperfil.startsWith("SECRETARIA")) {
            var numerosString = Nperfil.replace("SECRETARIA", "").trim();
            var numerosArray = numerosString.split("-");
            var codigoDinamico = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/unidade/${cod_unidade}`}>
                        {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });
            codigoDinamico.push(<NavDropdown.Item href="/metas">Painel de Metas</NavDropdown.Item>);
            codigoDinamico.push(<NavDropdown.Item key="tesouraria" href="/tesouraria"> Tesouraria - Pagamentos </NavDropdown.Item>);
            codigoDinamico.push(<NavDropdown.Item href="/alunos-cancelados">Alunos Cancelados</NavDropdown.Item>);
            codigoDinamico.push(<NavDropdown.Item href="/meus-alunos">Meus Alunos</NavDropdown.Item>);
            codigoDinamico.push(<NavDropdown.Item href="/alunos-nao-renovados">Alunos Não Renovados</NavDropdown.Item>);
            codigoDinamico.push(<NavDropdown.Divider />);
            var codigoDinamico2 = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/upload/${cod_unidade}`}>
                        Assinaturas - {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });
            codigoDinamico.push(<NavDropdown title="Assinaturas" id="basic-nav-subdropdown">{codigoDinamico2}</NavDropdown>);


            return (codigoDinamico)
        };

    }

    const handleCiclo = (e) => {
        e.preventDefault();
        // console.log('2026-09-01');
        setDataInicio('2026-08-28');
        // console.log('2027-09-31');
        setDataFim('2027-03-31');
    };

    const handleTotal = (e) => {
        e.preventDefault();
        setDataInicio('2026-08-28');
        setDataFim('2027-12-31');
    };

    const handleHoje = (e) => {
        e.preventDefault();
        // console.log('2026-09-01');
        setDataInicio('2026-08-28');
        // console.log('novaDataFim');
        setDataFim(diadehoje);
    };

    const handleSoHoje = (e) => {
        e.preventDefault();
        // console.log(diadehoje);
        setDataInicio(diadehoje);
        // console.log('novaDataFim');
        setDataFim(diadehoje);
    };


    return (

        <div className="Homepage">
            <div className="sticky-top painel">

                <Navbar expand="lg" className="bg-body-tertiary">

                    <Navbar.Brand href="/">Santa Mônica Rede de Ensino</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">

                        <NavDropdown
                            title="UNIDADES"
                        >
                            {Experiment(perfil[0].perfil)}
                            <NavDropdown.Item href="/tesouraria">Tesouraria - Pagamentos</NavDropdown.Item>

                        </NavDropdown>

                        <Row>
                            <Form onSubmit={handleData}>

                                <Row>
                                    <Col xs="auto">
                                        <InputGroup>
                                            <InputGroup.Text id="basic-addon1">Data Início</InputGroup.Text>
                                            <Form.Group >
                                                {/* <Form.Label >Data Início: </Form.Label> */}
                                                <Form.Control
                                                    name="inicio"
                                                    type="date"
                                                    value={dataInicio}
                                                    onChange={(e) => setDataInicio((valorAtual) => e.target.value || '2026-08-28')}
                                                    label="Data Início:"
                                                    className=" mr-sm-2" >

                                                </Form.Control>
                                            </Form.Group>
                                        </InputGroup>

                                    </Col>
                                    <Col xs="auto">
                                        <InputGroup>
                                            <InputGroup.Text id="basic-addon1">Data Fim</InputGroup.Text>
                                            <Form.Group >
                                                {/* <Form.Label htmlFor="floatingInput" >Data Início: </Form.Label> */}
                                                <Form.Control
                                                    name="fim"
                                                    type="date"
                                                    value={dataFim}
                                                    onChange={(e) => setDataFim((valorAtual) => e.target.value || diadehoje)}
                                                    label="Data Fim:"
                                                    className=" mr-sm-2" >
                                                </Form.Control>
                                            </Form.Group>
                                        </InputGroup>

                                    </Col>
                                    {/* <Col xs="auto">
                                        <Button variant="primary" type="submit">
                                            Filtrar datas
                                        </Button>
                                    </Col> */}

                                    <Col xs="auto">
                                        <Button variant="primary" onClick={handleCiclo}> Todo Ciclo  </Button>
                                    </Col>
                                    <Col xs="auto">
                                        <Button variant="primary" onClick={handleTotal}> Ano Completo  </Button>
                                    </Col>
                                    <Col xs="auto">
                                        <Button variant="primary" onClick={handleHoje} > Até Hoje  </Button>
                                    </Col>
                                    <Col xs="auto">
                                        <Button variant="primary" onClick={handleSoHoje} >  Hoje {formatarData(diadehoje)}  </Button>
                                    </Col>
                                    <Col xs="auto">
                                        <Button variant="primary" onClick={(e) => { navigate("\login") }} > Sair  </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Row>
                    </Navbar.Collapse>
                </Navbar>

                <Row >


                    <div className="totais">

                        <Col lg={12} sm={12}>
                            <center>
                                <h5>
                                    Totalização de Alunos da unidade <b> {unidades[parseInt(cod_unidade)]} </b>
                                </h5>
                            </center>
                            <Totalizacao_unidade di={dataInicio} df={dataFim} un={cod_unidade} />
                        </Col>
                    </div>

                </Row>
            </div>
            <br />
            <Row>
                <Col lg={12} sm={12}>
                    <center>
                        <h5>
                            Metas da unidade <b> {unidades[parseInt(cod_unidade)]} </b>
                        </h5>
                    </center>
                    <Metas_unidade di={dataInicio} df={dataFim} un={cod_unidade} />
                </Col>
            </Row>

            <br />
            <Row>
                <Col lg={3} sm={12}>
                    <center>
                        <h5>
                            Fidelização por Turma - <b> {unidades[parseInt(cod_unidade)]} </b>
                        </h5>
                        <Fidelizacao_turma di={dataInicio} df={dataFim} un={cod_unidade} />
                    </center>
                </Col>
                <Col lg={3} sm={12}>
                    <center>
                        <h6>
                            Fidelização por Série - <b> {unidades[parseInt(cod_unidade)]} </b>
                        </h6>
                        <Fidelizacao_serie di={dataInicio} df={dataFim} un={cod_unidade} />
                    </center>
                </Col>
                {/* <Col lg={3} sm={12}>
                    <center>
                        <h6>
                            Fidelização por Segmento - <b> {unidades[parseInt(cod_unidade)]} </b>
                        </h6>
                        <Fidelizacao_Seg_unidade di={dataInicio} df={dataFim} un={cod_unidade} />
                    </center>
                </Col> */}
                <Col lg={2} sm={12}>
                    <center>
                        <h6>
                            Fidelização Comparativa - <b> {unidades[parseInt(cod_unidade)]} </b>
                        </h6>
                        <Fidelizacao_serie_comparativa_unidade un={cod_unidade} />
                    </center>
                </Col>

                <Col lg={4} sm={12}>
                    <center>
                        <h5>
                            Alunos por Série - <b> {unidades[parseInt(cod_unidade)]} </b>
                        </h5>
                    </center>
                    <Alunos_novos_renovados_segmento di={dataInicio} df={dataFim} un={cod_unidade} />
                </Col>
            </Row>

            <br />
            <Row>
                <Col lg={12} sm={12}>
                    <center>
                        <h5>
                            Detalhamento de Bolsas da unidade <b> {unidades[parseInt(cod_unidade)]} </b>

                        </h5>
                        <Detalhamento_bolsa_tabs di={dataInicio} df={dataFim} un={cod_unidade} />
                    </center>
                </Col>
            </Row>
            {/* <Row>
                <center>
                    <h5>
                        Bolsas Médias
                    </h5>
                </center>
                <Col lg={3} sm={12}>
                    <Bolsa_media_unidade di={dataInicio} df={dataFim} un={cod_unidade} />
                </Col>
                <Col lg={3} sm={12}>
                    <Bolsa_diretor_unidade di={dataInicio} df={dataFim} un={cod_unidade} />
                </Col>
                <Col lg={3} sm={12}>
                    <Bolsa_balcao_unidade di={dataInicio} df={dataFim} un={cod_unidade} />
                </Col>
                <Col lg={3} sm={12}>
                    <Bolsa_bolsao_unidade di={dataInicio} df={dataFim} un={cod_unidade} />
                </Col>

            </Row> */}
            <br />
            <br />
            <br />
            <Row>
                <Col lg={3} sm={12}>
                    <center>
                        <h5>
                            Alunos por tipo de Bolsa - <b> {unidades[parseInt(cod_unidade)]} </b>
                        </h5>
                        <Bolsa_unidade di={dataInicio} df={dataFim} un={cod_unidade} />
                    </center>
                </Col>
                <Col lg={9} sm={12}>
                    <center>
                        {/* <Carteirinhas_pedidos di={dataInicio} df={dataFim} un={cod_unidade} /> */}
                    </center>
                </Col>
            </Row>
            <Row>
                <Col lg={12} sm={12}>
                    <center>
                        <h4>
                            Curva de Matriculas

                        </h4>
                        {/* <DashboardMatriculasUnidade di={dataInicio} df={dataFim} un={cod_unidade} /> */}

                    </center>

                </Col>
            </Row>
        </div>

    );
};

export default Unidade;